// export default [
//   null, // not in use
//   "Write", // not in use
//   "Upload data",
//   "Create data manually",
//   "External API data import",
//   // "Preview/view data",
//   "View data",
//   "Check for duplicate within data",
//   "Check for duplicate within database",
//   "Edit data",
//   "Overwrite data in the database",
//   "Data records",
//   "Delete data",
//   "Authorization",
//   "Create custom roles",
//   "Updata user roles",
//   "Remove user",
//   "Share data",
//   "View audit trail",
//   "Revert version history",
//   "Update Dashboard",
//   "Create metadata",
//   "Edit metadata",
//   "View metadata",
//   "Overwrite metadata",
//   "Delete metadata",
//   "Share metadata",
//   "Import metadata",
// ];

export default [
  "upload data",
  "create data manually",
  "external api data import",
  "view data",
  "check for duplicate within data",
  "check for duplicate within database",
  "edit data",
  "overwrite data in the database",
  "data records",
  "delete data",
  "authorization",
  "create custom roles",
  "update user roles",
  "remove user",
  "share data",
  "view audit trail",
  "revert version history",
  "update dashboard",
  "create metadata",
  "edit metadata",
  "view metadata",
  "overwrite metadata",
  "delete metadata",
  "share metadata",
  "import metadata",
];
